import { makeStyles } from '@material-ui/core';
import ArlaLogo from '../../../public/logos/Arla_Logo_Primary_RGB.png';
import {Flex} from '@backstage/ui';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 50,
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
    <Flex align="center" gap="1" direction="column">
      <img className={classes.img} src={ArlaLogo} alt="Arla" />
      <span>Developer Platform</span>
    </Flex>
  );
};

export default LogoFull;
